
export const commonUser = "User"
export const superUser = "Super User"
export const surveyorField = "Surveyor Field"
export const auditor = "Auditor"
export const userManager = "User Manager"
export const engineer = "Engineer"

